import {zhHans } from 'vuetify/locale';
import validations from "@/lang/zh_hans/validations";
import phoneCountryCodes from "@/lang/zh_hans/phone-country-codes";
import accountCategoryCodes from "@/lang/zh_hans/account-category-codes";
import changePassword from "@/lang/zh_hans/change-password";
import forgetPassword from "@/lang/zh_hans/forget-password";
import resetPassword from "@/lang/zh_hans/reset-password";
import userActivation from "@/lang/zh_hans/user-activation";
import regenQrcode from "@/lang/zh_hans/regen-qrcode";
import family from "@/lang/zh_hans/family";
import accountAssociation from "@/lang/zh_hans/account-association";
import loginInfo from "@/lang/zh_hans/login-info";
import otp from "@/lang/zh_hans/otp";
import buyerAccountActivation from "@/lang/zh_hans/buyer-account-activation";
import thirdPartyLink from "@/lang/zh_hans/third-party-link";
import emailForwarding from "@/lang/zh_hans/email-forwarding";
import campaignTeacherProfileUpdate from '@/lang/zh_hans/campaign-teacher-profile-update';

export default {
  $vuetify: zhHans,
  title: "香港教育城",
  forbidden: "你没有权限更新此页。 ",
  edcityHome: "教城主页",
  openMenu: "展开选单",
  closeMenu: "收起选单",
  accountSetting: "帐户设定",
  logout: "登出",
  submit: "提交",
  press: "按此",
  recaptchaLang: "zh-cn",  
  button: {
    submit: "提交",
    reset: "重设",
    close: "关闭",
    goEdCity: "进入教城网站",
  },
  fatalError: {
    unauthorized: "登入违时，请重新登入后再试一次。",
    unknown: "发生问题，请稍后再重新登入。如果问题仍然持续，请电邮至 support{'@'}edcity.hk。",
  },
  success: {
    basicProfileUpdated: "您的个人档案已更新。",
    basicProfileUpdatedIncludeLoginEmail:
      "您的个人档案已更新。确认电邮已经发送至{email}，请于{date}或之前确认变更。您的新登入电邮将会在认证程序完成后生效。",
    teacherProfileUpdated: "您的教师资料已更新。",
    teacherProfileUpdatedIncludeTeacherEmail:
      "您的教师资料已更新。确认电邮已经发送至{email}，请于{date}或之前以完成认证。",
    parentProfileUpdated: "您的家长资料已更新。",
    organizationAccountListUpdated: "帐户已更新。",
    organizationAccountListUploaded: "帐户已上载。",
    passwordIsChanged: "您已成功设定新密码。",
    accountActivated: "成功启动教育城户口及更新密码",
    loginQrcodeRegenerated: "您的登入二维码已刷新。",
    loginInfoUpdated:"您的登入讯息已更新。",
    emailForwardingUpdated:"您的电邮转寄设定已更新。",
    
  },
  campaignTeacherProfileUpdate,
  validations,
  phoneCountryCodes,
  accountCategoryCodes,
  changePassword,
  forgetPassword,
  resetPassword,
  userActivation,
  regenQrcode,
  family,
  accountAssociation,
  loginInfo,
  otp,
  buyerAccountActivation,
  thirdPartyLink,
  emailForwarding,
  profile: {
    menuList: {
      selfService: "自助服务",
      emailForwarding: "设定电邮转寄功能",
      myRecords: "我的记录",
      subscription: "订阅",
      edcityHomepage: "前往教城主页",
      editProfile: "新增／更新个人档案",
      basicProfile: "个人资料",
      teacherProfile: "教师身分资料",
      parentProfile: "家长身分资料",
      familyProfile: "绑定家庭",
      password: "密码",
      changePassword: "变更密码",
      regenQrcode: "变更登入二维码",
      accountAssociation:"帐户关联",
      loginInfo:"登入资讯",
    },
    basic: {
      heading: "更新个人资料",
      loginEmail: "登入电邮",
      loginEmailTooltip:
        "确认电邮将会发送到您输入的电邮地址，请点按电邮中的连结以确认变更。如您没有收到确认电邮或需作出其他更改，请重新提出确认要求。",
      accountInfoHeading: "帐户资料",
      cityId: "登入名称",
      accountCategory: "帐户类别",
      personalInfoHeading: "个人信息",
      title: "称谓",
      titles: {
        mr: "先生",
        mrs: "太太",
        miss: "小姐",
        ms: "女士",
      },
      chiSurname: "中文姓氏",
      chiGivenName: "中文名字",
      engSurname: "英文姓氏",
      engGivenName: "英文名字",
      displayName: "别名",
      displayNameTooltip: "可随时更改",
      generateDisplayName: "生成别名",
      contactEmail: "联络电邮",
      mobileCountryCode: "国家 或 地区",
      mobilePhoneNum: "手提电话号码",
      subscriptionHeading: "订阅教城资讯",
      subscription: "请选择您希望接收的电子报及活动资讯：",
      subscriptions: {
        edPost: "教城电子报",
        teacherInfo: "教师资讯",
        parentInfo: "家长资讯",
        studentInfo: "学生资讯",
      },
      thirdPartyHeading: "将第三方帐户与教城帐户连系",
      thirdPartyHeadingMember: "将第三方帐户与教城会员连系",
      thirdPartyAccount: "您可以使用以下第三方帐户登入教城网站。",
      connectInstruction: "请点击以下图示以连系 / 取消连系。",
      loginEmailUnaccepted: "@:{'registration.loginEmailUnaccepted'}",
      loginEmailInUse: "已有其他人选用此电邮地址。请使用其他电邮地址。",
      chiSurnameBadword: "切勿使用不雅用语，请输入其他中文姓氏。",
      chiGivenNameBadword: "切勿使用不雅用语，请输入其他中文名字。",
      engSurnameBadword: "切勿使用不雅用语，请输入其他英文姓氏。",
      engGivenNameBadword: "切勿使用不雅用语，请输入其他英文名字。",
      displayNameBadword: "切勿使用不雅用语，请输入其他别名。",
      displayNameInUse: "已有其他人选用此别名，请使用其他名称。",
      loginEmailPending: "此电邮地址已被登记，并正等待启用。",
      contactEmailRequired: "请输入您的电邮地址。",
      identityVerification: "身份验证",
      verificationMethod: "验证方式",
      iamsmart: "智方便",
      verificationDate: "验证日期",
      mobileVerification: {
        no: "未认证",
        yes: "已认证",
        verifyButton: "认证",
        reVerifyButton: "更改号码",
        sendSMSButton: "发送验证码",
        backToSendButton: "返回发送验证码",
        backToProfileButton: "返回个人资料",
        codeLabel: "输入验证码",
        heading: "认证手提电话号码",
        code: "验证码",
        info: "",
        verifySuccess: "验证成功",
        countdown: "验证码有效时间：",
        errors: {
          sendFail: "发送失败，请重试。",
        },
      },      
      upgradeStudentMemberPopUp: {
        title: "升级学生会员",
        intro:{
          desc: "为提供全方位个人化服务，您可以绑定您的校本专属帐户到个人会员帐户。个人会员帐户由您拥有，可以自行管理帐户及永久检视于教城完整的用户资料及活动纪录而不受升班或转校影响。",
          tos: "服务条款",
          acceptTos:
            "我已阅读并同意香港教育城订立的 {privacy}、 {copyright}、 {disclaimer}和 {tac}。",
          privacyStatement: "私隐政策声明",
          privateStatementUrl: "https://www.edcity.hk/home/zh-hant/dataprivacy",
          copyright: "版权及知识产权",
          copyrightUrl: "https://www.edcity.hk/notices/tc_chinese.php#s2",
          disclaimer: "免责声明",
          disclaimerUrl: "https://www.edcity.hk/notices/tc_chinese.php#s3",
          tac: "服务条款",
          tacUrl: "https://www.edcity.hk/notices/tc_chinese.php#s4",
          upgradeButton: "升级",
          skipButton: "跳过",
        },
        inputEmail: {
          stepTitle:"个人电邮",
          title:"输入您的个人电邮",
          desc:"升级学生会员可让您更容易管理您的学生帐户。除学校为您建立的登入名称或学校电邮外，您可使用个人电邮作登入用途。请输入您的个人电邮并进行认证。",
          email: "个人电邮",  
          sendButton: "发送验证码" 
        },
        verifyEmail: {
          stepTitle:"认证电邮",
          title: "输入您的个人电邮验证码",
          desc: "请输入发送到您个人电邮的验证码。输入后,请点击以下按钮以验证电子邮件",
          button: "验证",
          code: "验证码",
          verifySuccess: "验证成功",
          countdown: "验证码有效时间：",
          codeExpired: "验证码已逾时，请返回重新发送",
        },
        verifiedEmail: {
          title: "已成功验证!",
          desc: "您的电子邮件已被验证。现在您可以继续执行下一步来订阅教城资讯。",
          button: "下一步"
        },
        subscribeNews: {
          stepTitle:"订阅教城资讯",
          desc:"升级学生会员后, 您于学生帐户所订阅的教城资讯将转移到您的个人电邮。请确认或更改您的选项。",
          subscribeButton: "确认",
          cancelButton: "取消",
        },  
        linkEmail: {
          stepTitle:"绑定个人电邮",
          createDesc:"请输入新密码作为此个人电邮的登入资讯。请留意，学校管理员为您建立的登入资料同时存在而不会被改变。",
          updateDesc:"您所输入的个人电邮已经存在, 您确定要绑定至此学生帐户 ( 登入名称: {cityId} )吗? ",
          linkButton: "绑定",
          cancelButton: "取消",
        },
        finish: {
          stepTitle:"完成",
          title: "已成功升级!",
          desc:"恭喜您！您已成功升级学生会员。",
          finishButton: "完成",
        },       
        
      },

      upgradePopupStepTitle: {
        title: "申请升级会员",
        emailVer: "第一步 - 验证电子邮件地址",
        phoneVer: "第二步 - 验证手提电话号码",
        info: "第三步 - 更新用户个人资料",
        finish: "完成升级",
        next: "下一步",
        upgrade: "升级",
        lastStep:"上一步",
        stepper_email:"登入电邮",
        stepper_sms:"手提电话",
        stepper_info:"个人资料",
        stepper_done:"完成升级",
      },
      upgradePopupWelcome: {
        title: "申请升级会员",
        desc: "验证您的身分以体验所有功能。过程需时约 5 分钟",
        requirement: "您需要以下资料：",
        requirement1: "准备一个电邮地址",
        requirement2: "准备一个可以收发简讯的电话号码",
        requirement3: "个人讯息，包括性别、出生年份和地址",
        upgradeButton: "开始升级",
        skipButton: "跳过",
        errorMsg: "出了点问题，请稍后再试"
      },
      emailVerPopup: {
        title: "输入您的电邮地址",
        desc: "输入电邮地址后，请点击以下按钮以发送验证码到阁下的电邮",
        sendButton: "发送验证码",
        email: "电邮地址",
        emailInvalid: "无效的电邮地址",
        emailRequired: "请输入您的电邮地址",

      },
      emailCodeVerPopup: {
        title: "输入您的电邮验证码",
        desc: "请输入发送到您电邮地址的 6 位数验证码。",
        button: "验证",
      },
      emailVerifiedPopup: {
        title: "已成功验证!",
        desc: "您的电子邮件已被验证。现在您可以继续执行下一步来验证电话号码。",
        button: " 下一步",
      },
      mobileVerifiedPopup: {
        title: "已成功验证!",
        desc: "您的手提电话号码已被验证。现在您可以继续执行下一步来更新您的个人资料。",
        button: " 下一步",
      },
      verPopupFinish: {
        title: "已成功升级!",
        desc: "感谢升级您的帐户。您现在可以体验所有功能。",
        button: "完成",
      },
      verPopupInfo: {
        title: "更新用户个人资料",
        gender: "性别 ",   
        genderMale: "男",
        genderFemale: "女",
        yearOfBirth: "出生年份",      
        selfClaimTitle: "您的身分",
        selfClaimTeacher: "老师",
        selfClaimStudent: "学生",
        selfClaimParent: "家长",
        selfClaimRequired: "请选择您的身分", 
        genderRequired: "请选择性别", 
        birthRequired: "请选择出生年份", 
        addressLine1: "地址第一行",      
        addressLine2: "地址第二行",      
        region: "地区",      
        district: "区域",   
        button: "更新",
        regionHK: "香港",
        regionCN: "中国",
        regionMU: "澳门",
        regionOR: "其他",
        districtHK: {
          yuenLong: "元朗",
          yauTsimMong: "油尖旺",
          wongTaiSin: "黄大仙",
          wanChai: "湾仔",
          tuenMun: "屯门",
          tsuenWan: "荃湾",
          taiPo: "大埔",
          southern: "南区",
          shamShuiPo: "深水埗",
          shaTin: "沙田",
          saiKung: "西贡",
          north: "北区",
          kwunTong: "观塘",
          kwaiTsing: "葵青",
          kowloonCity: "九龙城",
          islands: "离岛",
          eastern: "东区",
          centralAndWestern: "中西区"
        }
      },
      address: {
        heading: "地址",
        region: "地区",
        district: "区域",
        chiAddressLine1: "中文地址第一行",
        chiAddressLine2: "中文地址第二行",
        engAddressLine1: "英文地址第一行",
        engAddressLine2: "英文地址第二行",
      },
      studentAccountInfo:{
        heading:"学校资料",
        info:"（学生资料，不能修改）",
        schoolName:"学校",
        chiFullName:"中文姓名",
        engFullName:"英文姓名",
        class:"班级(班号)",
        schoolEmail:"学校电邮",
        upgradeButton:{
          "studentMember":"升级学生会员",
          "fullMember":"升级会员",
        },
      },
    },
    teacher: {
      heading: "更新教师身分资料",
      teacherType: "请选择教师类别：",
      teacherTypes: {
        registered: "注册教师（需以教育局提供的e-Services帐户认证）",
        preService: "师训机构学生",
        prePrimary: "学前教育教师",
        universityTeacher: "大学教职员",
        retired: "退休教师",
        others: "其他类别教师",
        required: "请选择教师类别",
        invalid: "无效的教师类别",
      },
      teacherTypeHints: {
        registered:
          "认证电邮将会发送至以下的帐户，您需要登入e-Services系统(https://eservices.edb.gov.hk/)，查阅电邮，以完成认证。",
        preService: "认证电邮将会发送至以下的帐户，请查阅电邮，以完成认证。",
        universityTeacher:
          "认证电邮将会发送至以下的帐户，请查阅电邮，以完成认证。",
      },
      eservicesUserName: "e-services 帐户名称",
      eservicesUserNameRetype: "再次输入e-services 帐户名称",
      preServiceInstitution: "就读的教育机构",
      teacherInstitution: {
        required: "请选择教育机构",
        invalid: "无效的教育机构",
      },
      teacherEmail: {
        required: "请提供电邮地址",
        invalid: "无效的电邮地址",
        duplicated: "电邮地址已用于其他教城帐户。请使用其他电邮地址再次登记。",
        improper: "您所输入的电邮地址不正确 / 不适当。",
      },
      preServiceUserName: "学校帐户名称",
      preServiceUserNameRetype: "再次输入学校帐户名称",
      preServiceEmailDomain: {
        required: "请提供学校电邮域名",
      },
      universityTeacherInstitution: "在职的教育机构",
      universityTeacherUserName: "学校帐户名称",
      universityTeacherUserNameRetype: "再次输入学校帐户名称",
      universityTeacherEmailDomain: {
        required: "请提供学校电邮域名",
      },
      schoolInfoHeading: "任职学校（需经由学校管理员上载）",
      school: "学校",
      schoolName: "{name} （教城学校代号：{code}）",
      schoolEmail: "学校电邮",
      schoolEmailDomain: "学校电邮域名",
       schoolStaffInfo: {
        contactPerson:{
           title: "查阅学校管理员资料",
            heading: "查阅学校管理员资料",
           staffName: "学校管理员姓名",
           description: "如需更新学校电邮，请联络 贵校学校管理员：",
        },
        buyer:{ 
          title: "查阅学校采购员资料",
          heading: "查阅学校采购员资料",
          staffName: "学校采购员姓名",
          description: "如需为学校采购校本服务，请联络 贵校采购员：",
        },       
        schoolName: "学校名称",       
        staffContactCountryCode: "国家或地区（联络电话）",
        staffContactNumber: "联络电话",
        staffContactEmail: "联络电邮",
        closeWindow: "关闭",        
        invalid: "此功能只供校本老师使用，请更换帐户再尝试。",
      },
      teachingSubjectHeading: "主要任教科目/学习领域",
      subjectList: {
        invalid: "无效的资料格式",
      },
      teachingLevel: "任教程度",
      teachingLevels: {
        prePrimary: "学前",
        primary: "小学",
        secondary: "中学",
        tertiary: "大专",
        special: "特殊学校",
      },
      curriculumList: {
        basicEdu: "特殊教育（基础教育课程）",
        seniorSec: "特殊教育（高中教育课程）",
        basicEduId: "特殊教育（智障学生：基础教育课程）",
        seniorSecId: "特殊教育（智障学生：高中课程）",
        gsPri: "小学常识科",  
        langPri: "语文教育", 
        langSec: "语文教育",        
        sciSec: "科学教育",
        techSec: "科技教育",
        psheSec: "个人、社会及人文教育",
      },
      teachingSubject: "请选择：",
      dutyHeading: "主要校内职务",
      dutyRemarkHeading: "其他职务",
      interestAreaHeading: "关注项目",
      interestAreaList: {
        invalid: "无效的资料格式",
      },
      dutyList: {
        invalid: "无效的资料格式",
      },
      dutyRemark: {
        required: "请提供其他校内职务",
        invalid: "无效的资料格式",
      },
      o365AccountHeading: "Microsoft Office 365 教育版帐户",
      o365AccountDescription:
        "透过结合教城完备的教师会员系统及Microsoft Office 365 教育版 （Office 365 A1）帐户的全面功能，免费支援教师轻易地展开遥距教学，以及与同侪互相交流，促进跨校合作，共建专业教育社群。",
      applyO365AccountInstruction:
        "想免费申请Microsoft Office 365 教育版帐户? {action}",
      o365LoginName: "登入名称",
      useO365Instruction: "请登入 Microsoft Office 365 {link} 享用服务",
      authType: {
        invalid: "无效的帐户认证类别",
      },
      eservicesUserNameUnmatch:
        "您所输入的@:{'profile.teacher.eservicesUserName'}不相符。请重新输入。",
      preServiceUserNameUnmatch:
        "您所输入的@:{'profile.teacher.preServiceUserName'}不相符。请重新输入。",
      universityTeacherUserNameUnmatch:
        "您所输入的@:{'profile.teacher.universityTeacherUserName'}不相符。请重新输入。",
    },
    parent: {
      heading: "更新家长身分资料",
      interestAreaHeading: "主要关注项目",
    },
  },
  edbRegistration: {
    heading: "登记香港教育城（教城）会员帐户",
    loginEmailUserName: "教育局电邮",
    reconfirmLoginEmailUserName: "确认教育局邮件",
    step1: "提供教育局的电邮地址",
    step2: "接收电子邮件通知",
    step3: "准备使用教城服务",
    description:
      "欢迎各位教育局同工登记成为香港教育城（教城）的会员！作为教育局的策略性伙伴，教城希望阁下能够更了解和掌握我们为学界提供的一系列学与教资源及服务，藉此促进合作发展。为此，我们设立了一个简单的帐户启动机制，让阁下可以简便地申请属于你的教城会员帐户。<br> <br> 阁下只须填写你的教育局电邮地址，我们便会即时把你的会员帐号和启动帐户的连结电邮给你<font color='#FF0000'>*</font>。你的会员身分等同于校本教师帐户，阁下可以使用这个帐户，使用教城的校本服务。",
    reminder:
      "<small><font color='#FF0000'>*</font>如阁下的教育局电邮地址失效，相应的教城会员帐户亦会自动停止服务。</small>",
    contact: "如有任何查询，请电邮往 {supportEmail}。",
    supportEmailLink: "mailto: support{'@'}edcity.hk",
    supportEmail: "support{'@'}edcity.hk",
    registerButton: "登记教城帐户",
    submitCreate: "提交登记",
    completed:
      "欢迎登记成为香港教育城（教城）会员。您的帐户登入电邮是 {loginEmail} 。启动帐户电邮已发送至 {emailSentTo} 。",
    loginEmailUnaccepted: "此电邮不能作为登记用户，请使用其他电邮登记。",
    loginEmailInUse: "电邮地址已用于其他教城帐户。请使用其他电邮地址再次登记。",
    loginEmailPending: "此电邮地址已被登记，并正等待启用。",
  },
  registration: {
    heading: "建立个人帐户",
    accountAssociationDesc: "自动关联至您的学生帐户(登入名称: {linkedLoginId} )",    
    notAllowLinkUser: "抱歉。此连结无效。",
    loginEmail: "登入电邮",
    loginEmailHint: "以此电邮登入帐户",
    surname: "姓氏",
    givenName: "名字",
    tos: "服务条款",
    acceptTos:
      "我已阅读并同意香港教育城订立的 {privacy}、 {copyright}、 {disclaimer}和 {tac}",
    privacyStatement: "私隐政策声明",
    privateStatementUrl: "https://www.edcity.hk/home/zh-hans/dataprivacy/",
    copyright: "版权及知识产权",
    copyrightUrl: "https://www.edcity.hk/home/zh-hans/copyright/",
    disclaimer: "免责声明",
    disclaimerUrl: "https://www.edcity.hk/home/zh-hans/disclaimer/",
    tac: "服务条款",
    tacUrl: "https://www.edcity.hk/home/zh-hans/notices/",
    submitCreate: "建立帐户",
    completed:
      "欢迎登记成为教城会员。您的帐户登入电邮是 {loginEmail} 。启动帐户电邮已发送至 {emailSentTo} 。请于 {validThru} 或之前启动帐户，否则须重新登记。",
    loginEmailUnaccepted: "此电邮不能作为登记用户，请使用其他电邮登记。",
    loginEmailInUse: "电邮地址已用于其他教城帐户。请使用其他电邮地址再次登记。",
    loginEmailPending: "此电邮地址已被登记，并正等待启用。",
    alreadyVerifiedAsTeacher: "电邮地址已用于其他教城个人教师帐户。请使用其他电邮地址再次登记。",
    surnameBadword: "切勿使用不雅用语，请输入其他姓氏。",
    givenNameBadword: "切勿使用不雅用语，请输入其他名字。",
    birth:
      "出生年份",
    gender: {
      label:
        "性别",
      female:
        "女",
      male:
        "男",
    },

    selfClaimRolesList: {
      heading:
        "您的身分:",
      label:
        "身分",
      TEACHER:
        "老师",
      STUDENT:
        "学生",
      PARENT:
        "家长"
    },
    closeBtn: "关闭",
    manualCloseMsg:"请关闭此视窗。成功启动教育城帐户后，请返回应用程式并手动点击「登入」按钮以完成登入。"
  },
  teacherAuthVerify: {
    heading: "教城教师帐户验证",
    success: "您已成功更改验证教师帐户。",
    fail: "错误！",
    required: "请提供验证连结。",
    invalid: "这不是正确的确认电邮网址！",
    verified: "验证连结已被使用。",
    expired: "这连结已超时失效。",
    teacherEmail: {
      duplicated: "电邮地址已用于其他教城帐户。请使用其他电邮地址再次登记。",
    },
    user: {
      invalid: "帐户无效。",
    },
  },
  loginEmailVerification: {
    heading: "确认电邮地址为登入帐号",
    submit: "确认",
    success: "您已成功更改登入电邮至 {email}。",
    fail: "错误！",
    invalid: "这不是正确的电邮确认网址！",
    verified: "验证连结已被使用。",
    expired: "这连结已超时失效。",
    duplicated: "此电邮地址已用于其他教城帐户作登入电邮。",
  },
  contactEmailVerification: {
    heading: "确认更改联络电邮",
    submit: "确认",
    success: "您已成功更改联络电邮至 {email}。",
    fail: "错误！",
    invalid: "这不是正确的电邮确认网址！",
    verified: "验证连结已被使用。",
    expired: "这连结已超时失效",
  },
  emailSubscriptionVerification: {
    heading: "确认更改订阅",
    success: "您已成功更改订阅至：",
    fail: "错误！",
    invalid: "这不是正确的电邮确认网址！",
    verified: "验证连结已被使用。",
    expired: "这连结已超时失效。",
  },
  organizationAccountList: {
    itemsPerPage: {
      0: "每页显示",
      1: "行",
    },
    teacher_type: {
      PRE_SERVICE: "学生",
      UNIVERSITY_TEACHER: "教职员"
    },
    readOnly: "只读模式",
    emailAddress: "电邮地址",
    chFullName: "中文姓名",
    enFullName: "英文姓名",
    remark: "备注",
    updatedAt: "修改时间",
    updatedBy: "修改者",
    actions: "动作",
    add: "新增",
    edit: "修改",
    save: "储存",
    cancel: "取消",
    delete: "删除",
    confirm: "您确定要删除此记录吗？",
    search: "搜寻",
    group: "选择群组：",
    itemsPerPageText: "每页显示：",
    pageText: "{0}-{1} 共 {2} 个纪录",
    import: "汇入",
    editItem: {
      emailAddress: {
        label: "电邮地址",
        validation: {
          maxLength: "输入长度超过限制",
          duplicated: "输入电邮地址已重覆",
          improper: "输入电邮地址格式不正确",
        },
      },
      chFullName: {
        label: "中文姓名",
        validation: {
          maxLength: "输入长度超过限制",
        },
      },
      enFullName: {
        label: "英文姓名",
        validation: {
          maxLength: "输入长度超过限制",
        },
      },
      remark: {
        label: "备注",
        validation: {
          maxLength: "输入长度超过限制",
        },
      },
      updatedAt: {
        label: "修改时间",
      },
      updatedBy: {
        label: "修改者",
      },
    },
    importFile: {
      label: "请选择 .xlsx 档案",
      validation: {
        file: {
          required: "请提供汇入档案",
          invalid: "汇入档案格式不正确",
          exceedMax: "汇入档案不可超过1,000条记录",
        },
        emailAddress: {
          invalid: "汇入档案中的电邮格式不正确",
          improper: "汇入档案中的电邮不正确",
          duplicated: "汇入档案中的电邮地址已重覆",
          exceedMax: "汇入档案中的电邮地址输入长度超过254字元限制",
        },
        chFullName: {
          invalid: "汇入档案中的中文姓名不正确",
          exceedMax: "汇入档案中的中文姓名输入长度超过100字元限制",
        },
        enFullName: {
          invalid: "汇入档案中的英文姓名不正确",
          exceedMax: "汇入档案中的英文姓名输入长度超过100字元限制",
        },
        remark: {
          invalid: "汇入档案中的备注不正确",
          exceedMax: "汇入档案中的备注输入长度超过100字元限制",
        },
      },
      downloadTemplate: "下载「XLS/XLSX」 范本",
    },
    export: "汇出",
    emailAddressUnaccepted: "无效的电子地址。",
  },
  googleSSO: {
    fail: "错误！",
    close: "关闭",
    heading: "导出Google帐户供香港教育城单一登入注册",
    clientId: "用户端 ID",
    domain: "网域",
    getUsers: "查询使用者",
    exportToExcel: "下载至 Excel 档案",
  },
  subscription: {
    label: {
      email: "电邮地址",
      confirmEmail: "再次输入电邮地址",
    },
    button: {
      confirm: "确认订閲",
      reset: "重设",
      close: "关闭",
      backToHome: "返回主页",
    },
    validations: {
      emailIsEmpty: "请输入电邮地址。",
      emailFormatWrong: "电邮地址格式不正确，请重新输入。",
      serviceIsEmpty: "请选择希望接收的电子报及活动资讯。",
      confirmEmailIsEmpty: "请输入有效电邮地址格式。",
      confirmEmailIsNotSame: "您所输入的电邮地址不一致，请重新输入。",
    },
    text: {
      emailIntro: "输入电邮地址收取资讯<span class='text-red'>*</span>",
      UseDataHeading: "使用个人资料作直接促销",
      emailConfirm: "我们收到订阅后，会于当天发出确认电邮。",
      emailVerification: "验证电子邮件已传送至您的电子邮件地址。请点击电子邮件中的连结确认您的订阅。",
      useDataContent: "<p>教城拟使用阁下的个人资料（包括姓名、电话号码及电邮地址）以通知阁下有关教城及其合办机构及支持机构的教育最新动向、优惠、活动、服务及产品。此等直接促销会根据教城的私隐政策严格执行。阁下亦可随时选择不再接收这些电邮。教城在未得到阁下的同意前，不会使用阁下的个人资料作上述用途。 </p><p>本人愿意接收电子报及有关教城及其合办机构及支持机构的教育最新动向、优惠、活动、服务及产品的资讯。</p>",
      successHeading: "多谢您订阅教城资讯",
      successInfo: "您将接收以下的电子报及活动资讯：",
    },
  },
  region: {
    HONGKONG: "香港",
    MACAU: "澳门",
    CHINA: "中国",
    OTHER: "其他",
  },
  districtHK: {
    YUENLONG: "元朗",
    YAUTSIMMONG: "油尖旺",
    WONGTAISIN: "黄大仙",
    WANCHAI: "湾仔",
    TUENMUN: "屯门",
    TSUENWAN: "荃湾",
    TAIPO: "大埔",
    SOUTHERN: "南区",
    SHAMSHUIPO: "深水埗",
    SHATIN: "沙田",
    SAIKUNG: "西贡",
    NORTH: "北区",
    KWUNTONG: "观塘",
    KWAITSING: "葵青",
    KOWLOONCITY: "九龙城",
    ISLANDS: "离岛",
    EASTERN: "东区",
    CENTRALANDWESTERN: "中西区",
  }
};